import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LoadingIndicator from '../v2/LoadingIndicator';

const FULL_VH = document.documentElement.clientHeight;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--sys-color--surface);
  height: ${({ headerHeight }) => FULL_VH - headerHeight}px;
  position: absolute;
  top: 0;
  width: 100vw;
  padding-bottom: ${({ headerHeight }) => headerHeight}px;
  box-sizing: border-box;
`;

const LoadingPage = ({ headerHeight }) => (
  <LoadingContainer headerHeight={headerHeight || 0}>
    <LoadingIndicator showContainer={true} />
  </LoadingContainer>
);

LoadingPage.propTypes = {
  headerHeight: PropTypes.number
};

export default LoadingPage;
